import { createContextKey } from '@connectrpc/connect';
import { type QueryClient } from '@tanstack/react-query';

export const ctxKeyAuthorized = createContextKey<boolean>(true, {
  description: 'Authorization required',
});

export const ctxKeyQueryClient = createContextKey<QueryClient>(null as never, {
  description: 'Default query client instance',
});
